import React from 'react';
import PropTypes from 'prop-types';
import _includes from 'lodash/includes';
import CONST from '@/utils/Constants/General';

// context
import { useSearchContext } from '@/context/search';

// hooks
import useSearchLoad from '@/hooks/search/useSearchLoad';
import useSearchChangeTab from '@/hooks/search/useSearchChangeTab';
import useSearchPopstate from '@/hooks/search/useSearchPopstate';
import useSearchPagination from '@/hooks/search/useSearchPagination';
import useSearchChangeQuery from '@/hooks/search/useSearchChangeQuery';
import useSearchUpdateCounts from '@/hooks/search/useSearchUpdateCounts';

// components
import Tabs from '@/components/molecules/Tabs';
import ServiceFilter from '@/components/organisms/ServiceFilter';

const SearchApp = ({
  tabsData,
  sortsData,
  searchType,
  searchTerm,
  hasLoadMore,
}) => {
  const [
    { activeTab, tabs, filters },
    { setActiveTab, applyFilter, clearFilters, applySort },
  ] = useSearchContext();

  // hooks
  useSearchLoad({ tabsData, sortsData, searchType, searchTerm, hasLoadMore });
  useSearchChangeTab();
  useSearchPopstate();
  useSearchPagination();
  useSearchChangeQuery();
  useSearchUpdateCounts();

  if (tabs.length === 0) return null;

  const hasFilters = _includes(
    [CONST.SEARCH.TYPE.PRODUCT, CONST.SEARCH.TYPE.RECIPE],
    activeTab.type,
  );

  return (
    <>
      <Tabs
        tabs={tabs}
        modifiers={['bold']}
        onClick={tab => setActiveTab(tab.type)}
        activeAttribute='isLoaded'
        hasUpdateLine
      />
      {hasFilters && (
        <ServiceFilter
          showSort={CONST.SEARCH.TYPE.PRODUCT === activeTab.type}
          filters={filters}
          searchType={`js-search-tab-${activeTab.type}`}
          onApplyFilter={applyFilter}
          onClearFilters={clearFilters}
          onApplySort={applySort}
        />
      )}
    </>
  );
};

SearchApp.propTypes = {
  tabsData: PropTypes.string.isRequired,
  sortsData: PropTypes.string.isRequired,
  hasLoadMore: PropTypes.string.isRequired,
  searchType: PropTypes.string.isRequired,
  searchTerm: PropTypes.string.isRequired,
};

SearchApp.defaultProps = {};

export default SearchApp;
